<template>
  <v-app>
    <router-view></router-view>
    <v-dialog v-model="loading" fullscreen>
      <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout justify-center align-center>
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("app", {
      loading: state => state.loading
    }),
    ...mapState("auth", {
      isAuthenticated: state => state.isAuthenticated
    })
  },
  watch: {
    isAuthenticated: function(auth) {
      this.goToLogin(auth);
    }
  },
  mounted: function() {
    this.initialize();
  },
  methods: {
    goToLogin(auth) {
      if (auth == false && this.$route.path !== "/login") {
        this.$router.push("/login");
      }
    },
    initialize() {
      this.$store.dispatch("services/getApiList");
      this.$store.dispatch("services/getServiceTypes");
      this.goToLogin(this.isAuthenticated);
    }
  }
};
</script>